const STORAGE_KEY = 'biblika_random_pool';

export function loadRandomPool() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function saveRandomPool(enabledIds) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(enabledIds));
}

export function getEnabledGames(allGames) {
  const pool = loadRandomPool();
  if (!pool) return allGames;
  const enabled = allGames.filter((g) => pool.includes(g.id));
  return enabled.length > 0 ? enabled : allGames;
}
